import { ChangeEvent } from 'react'
import { useAppDispatch } from '../../../../../../ReduxToolkit/Hooks';
import { filterSearchBy } from '../../../../../../ReduxToolkit/Reducers/FilterSlice';
import { Col, Form, FormGroup, Input } from 'reactstrap';
import { Search } from '../../../../../../utils/Constant';

const SearchBox = () => {
    const dispatch = useAppDispatch();
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(filterSearchBy(event.target.value));
    };
    return (
      <Col md="9" sm="12">
        <Form>
          <FormGroup className="form-group m-0">
            <Input type="search" placeholder={Search} onChange={handleSearchChange} />
            <i className="fa fa-search"></i>
          </FormGroup>
        </Form>
      </Col>
    )
}

export default SearchBox